/**
 * GiftCardCustomerBlock — the summary card's Customer section (BON-223): name
 * + email with an avatar when a customer is linked, else the italic
 * "No customer linked to this card." placeholder — cards bought as gifts stay
 * unregistered until the recipient claims one.
 */
import { Avatar } from '../dashboards/primitives';

import type { GiftCardCustomer } from './giftCardTypes';

export function GiftCardCustomerBlock({ customer }: { customer: GiftCardCustomer | null }) {
  return (
    <div style={{ borderTop: '1px solid var(--nb-border)', paddingTop: 14 }}>
      <div
        style={{
          fontSize: 10,
          fontWeight: 800,
          letterSpacing: '.06em',
          textTransform: 'uppercase',
          color: 'var(--nb-subtle)',
          marginBottom: 6,
        }}
      >
        Customer
      </div>
      {customer?.name ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Avatar name={customer.name} color="var(--nb-primary)" size={30} />
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 13.5, fontWeight: 700 }}>{customer.name}</div>
            {customer.email && (
              <div
                style={{
                  fontSize: 11.5,
                  color: 'var(--nb-subtle)',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {customer.email}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div style={{ fontSize: 12.5, color: 'var(--nb-faint)', fontStyle: 'italic' }}>
          No customer linked to this card.
        </div>
      )}
    </div>
  );
}
